<template>
    <div>
      <h1>404 - Page Not Found</h1>
      <p>对不起，请求的页面不存在。</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NotFound'
  };
  </script>
  